export default __webpack_public_path__ + "static/media/music.24e6cc57.mp3";